import { useState } from 'react'
import { Modal } from 'shared'
import {connect} from 'formik'

import {CodonationCalculator} from './codonation_calculator'
import {CodonationCalculatorModest} from './codonation_calculator_modest'
import {formatCents, parseCents, gaEvent, sanitizeMoney} from 'shared'

const images = [
  'https://betterplace-assets.betterplace.org/assets/donations/codonation/slider/state-6-765296894be78b3726e53a65575743a2092ccd9cc1cf065aa4183e0fd10f656b.png',
  'https://betterplace-assets.betterplace.org/assets/donations/codonation/slider/state-12-ef1c576dab84a19e769f16949a8f9231cd06e3e1e29a29971d99d2e03f6d8d7a.png',
  'https://betterplace-assets.betterplace.org/assets/donations/codonation/slider/state-14-2f3d297498aa5993f5d8ddf28ce56dd46a53491e834b59273fecf8ee426ccbf2.png',
]

export const CodonationSelection = ({config, display}) => {
  const [showCodonationModal, setShowCodonationModal] = useState(false)
  const openModal = () => {
    gaEvent('engagement', 'click codonation_modal_open_link')
    setShowCodonationModal(true)
  }
  const hideCodonationModal = () => {
    setShowCodonationModal(false)
  }

  return <div className='donations-form-codonation-selection' style={{ textAlign: 'left' }}>
    <button className='simulated-link text-base whitespace-normal text-left' type='button' onClick={openModal}>{I18n.t('donate.codonation_selection.codonation_modal.open_button')}</button>

    <Modal
      id='codonation-selection-modal'
      onHide={() => {
        gaEvent('engagement', 'click codonation_modal_close_link')
        hideCodonationModal()
      }}
      show={showCodonationModal}
      header={I18n.t(`donate.codonation_selection.codonation_modal.${config.wording}.headline`, { receiver_name: display.receiverName })}
      size='modal-lg'
    >
      <ModalContent config={config} display={display} handleClose={hideCodonationModal} />
    </Modal>
  </div>
}

const ModalContent = connect(({formik, config, display, handleClose}) => {
  const calc = CodonationCalculatorModest.appliesTo(formik.values) ? CodonationCalculatorModest : CodonationCalculator
  const prefills = calc.prefills(formik.values.amount_cents)
  const [value, setValue] = useState(formik.values.codonation_cents / 100)

  const storeAndClose = (cents) => {
    formik.setFieldValue('codonation_cents', cents)
    formik.setFieldTouched('codonation_cents', true)
    handleClose()
  }

  const handlePredefinedAmountSelection = (cents, boxPosition) => {
    gaEvent('engagement', 'click codonation_amount_box', boxPosition)
    storeAndClose(cents)
  }

  const handleApplyButtonClick = () => {
    if (calc.suggest(formik.values.amount_cents) !== parseCents(value)) {
      gaEvent('engagement', 'change codonation_amount_input', sanitizeMoney(value))
    }
    storeAndClose(parseCents(value))
  }

  const handleEnter = (event) => {
    if (event.key == 'Enter') {
      storeAndClose(parseCents(event.target.value))
    }
  }

  return <div className='donations-form-codonation-selection'>
    <p>{I18n.t(`donate.codonation_selection.codonation_modal.${config.wording}.platform_introduction`)}</p>

    <h3 className='text-lg'>{I18n.t(`donate.codonation_selection.codonation_modal.${config.wording}.call_to_action`)}:</h3>

    <div className='flex mt-3 mb-3'>
      <PredefinedAmountBox cents={prefills[0]} imageSrc={images[2]} boxPosition={1} onClick={handlePredefinedAmountSelection} />
      <PredefinedAmountBox cents={prefills[1]} imageSrc={images[1]} boxPosition={2} onClick={handlePredefinedAmountSelection} />
      <PredefinedAmountBox cents={prefills[2]} imageSrc={images[0]} boxPosition={3} onClick={handlePredefinedAmountSelection} />
    </div>

    <div className='custom-codonation-input-wrapper'>
      <label>{I18n.t('donate.codonation_selection.codonation_modal.amount_label')}</label>
      <div className='input-group'>
        <input
          className='form-control'
          type='text'
          inputMode='decimal'
          value={value}
          onChange={({target}) => setValue(target.value)}
          onKeyPress={handleEnter}
        />
        <div className='input-group-append'>
          <span className='input-group-text'>€</span>
        </div>
      </div>
      <button className='btn btn-primary' type='button' onClick={handleApplyButtonClick}>
        {I18n.t('donate.codonation_selection.codonation_modal.change_amount_button')}
      </button>
    </div>

    {
      display.carrierName && <div className="row">
        <div className="col-md-24">
          <div className="organisation">
            <img src={display.carrierProfilePicture} />
            <p>{I18n.t(`donate.codonation_selection.codonation_modal.${config.wording}.trust_teaser`, { carrier_name: display.carrierName })}</p>
          </div>
        </div>
      </div>
    }
  </div>
})

const PredefinedAmountBox = ({ cents, imageSrc, boxPosition, onClick }) => {
  return <div className='predefined-amount-box has-show-buttons-hovered' onClick={() => onClick(cents, boxPosition)}>
    {formatCents(cents)}
    <div className='image-wrapper'>
      <img src={imageSrc} alt='' />
    </div>
    <span className='btn btn-primary'>{I18n.t('donate.codonation_selection.codonation_modal.choose_button')}</span>
  </div>
}
